import React from 'react'
import { Button, Dropdown } from 'antd'
import sillabus from '../fayl/meyoriy_xujjatlar/5.sillabbus.pdf'
import ND from '../fayl/meyoriy_xujjatlar/5.ND.pdf'

const items =[
  {
      key: '1',
      label:( <a href={ND}>Namunaviy dastur</a> )
  },
    {
        key: '2',
        label: ( <a href={sillabus} > Sillabus</a> )
    },
]

export const Meyoriyxujjat = () => {
  return (
    <div>
        <Dropdown menu={{items}} placement='bottom' arrow={{pointAtCenter: true}}>

        <Button className='button'>Meyoriy xujjatlar</Button>
        </Dropdown>
    </div>
  )
}
